import React from 'react';
import { connect } from 'react-redux';
import { Loader } from 'web-ui-components/lib/organisms/modals';
import { loading } from './selectors';
import { Content } from '../content';

const LoaderComponent = isOpen => (
  <Content>
    {({ loaderTitle, loaderBody }) => (
      <Loader isOpen={isOpen.isOpen} title={loaderTitle} body={loaderBody} />
    )}
  </Content>
);

const mapStateToProps = state => ({
  isOpen: loading(state)
});

export default connect(mapStateToProps)(LoaderComponent);
